import { render, staticRenderFns } from "./ProjectStats.vue?vue&type=template&id=a439ef34&scoped=true&"
import script from "./ProjectStats.vue?vue&type=script&lang=js&"
export * from "./ProjectStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a439ef34",
  null
  
)

export default component.exports